"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RdfDereferencerBase = void 0;
const core_1 = require("@comunica/core");
/**
 * An RdfDerefencer can dereference URLs to RDF streams, using any RDF serialization.
 */
class RdfDereferencerBase {
    constructor(args) {
        this.mediatorRdfDereference = args.mediatorRdfDereference;
    }
    /**
     * Dereference the given URL to an RDF stream.
     * @param {string} url An HTTP(S) HTTPS URL.
     * @param {IDereferenceOptions} options
     * @return {IActorRdfDereferenceOutput} The dereference output.
     */
    dereference(url, options = {}) {
        // Delegate dereferencing to the mediator
        return this.mediatorRdfDereference.mediate({
            context: core_1.ActionContext(options),
            headers: options.headers,
            method: options.method,
            url,
        });
    }
}
exports.RdfDereferencerBase = RdfDereferencerBase;
//# sourceMappingURL=RdfDereferencerBase.js.map